<template lang="pug">
  v-dialog(v-model="show", width="50%", max-height="70%")
    v-card
      v-card-title.title Tempo de Entrega - {{ this.estabelecimentoSelecionado ? this.estabelecimentoSelecionado.nome : 'Todas as Lojas'}}
      v-card
        v-card-text
          v-layout(row, wrap, v-if="!estabelecimentoSelecionado")
            v-flex.md12
              v-text-field(append-icon='search', outline, color="gray", label='Buscar loja', type="text", v-model="search", clearable)
          v-layout(row, wrap)
            v-flex.md12
              v-list(three-line)
                template(v-for='(estabelecimento, i) in estabelecimentosVisiveis', v-if="estabelecimento.delivery[0].dias_entrega && estabelecimento.delivery[0].dias_entrega !== ''")
                  v-list-tile.my-2
                    v-list-tile-content(style="max-width:50%!important")
                      v-list-tile-title.content-text {{ estabelecimento.nome }}
                      v-list-tile-sub-title.content-text {{estabelecimento.localidade}} - {{estabelecimento.estado}}
                      v-list-tile-sub-title.content-text
                        BadgeOrigem(:cardapio_digital="estabelecimento.cardapio_digital ? true : false", :label="true")
                      v-list-tile-sub-title.content-text
                        small.caption {{secToMin(estabelecimento.delivery[0].tempo_entrega)}}
                    v-list-tile-action(style="min-width:50%!important")
                      v-slider.my-0.ml-5(v-model="estabelecimento.delivery[0].tempo_entrega" @change="update(estabelecimento.delivery[0])" thumb-label="always", :thumb-size="24", :step="5", :min="5", :max="180", color="primary")
                  v-divider
                v-list-tile(v-if="totalRestante > 0", ref="sentinela", @click="mostrarMais()")
                  v-list-tile-content
                    v-list-tile-title.text-xs-center.primary--text Mostrar mais {{ proximoPasso }} (restam {{ totalRestante }})
        v-card-actions
          v-spacer
          v-btn(@click="close();", flat) Fechar
</template>

<script>
import _ from "lodash";
import BadgeOrigem from "@/components/BadgeOrigem";
import listaLojasIncremental from "@/mixins/listaLojasIncremental";


export default {
  mixins: [listaLojasIncremental],
  components: {
    BadgeOrigem
  },
  props: {
  },
  data () {
    return {
        show : false,
        search: null,
        // aplicado com debounce: evita refiltrar a lista inteira a cada tecla
        searchAplicado: null,
        loading: false,
        estabelecimento: null,
        delivery: null,
        estabelecimentoDisponiveis: []
    }
  },
  created () {
    window.getApp.$on("UPDATE_DELIVERY_LIST", this.updateEstabelecimentos);
    this.aplicarBusca = _.debounce(valor => {
      this.searchAplicado = valor;
      this.resetLimite();
    }, 200);
  },
  beforeDestroy() {
    window.getApp.$off("UPDATE_DELIVERY_LIST", this.updateEstabelecimentos);
    if (this.aplicarBusca) this.aplicarBusca.cancel();
  },
  mounted() {

  },
  watch: {
    '$root.estabelecimentos': {
      handler () {
        this.updateEstabelecimentos()
      },
    },
    search (valor) {
      this.aplicarBusca(valor || null);
    },
  },
  computed: {
    listaOrdenada(){
      return _.sortBy(this.estabelecimentoDisponiveis, 'nome')
    },
    estabelecimentos(){
      return this.$root.searchLojas(this.listaOrdenada, this.searchAplicado)
    },
    estabelecimentoSelecionado(){
      return this.$root.estabelecimentoSelecionado;
    }
  },
  methods: {
    updateEstabelecimentos(){
      if(this.show == false) return;
      this.estabelecimentoDisponiveis = _.cloneDeep(this.$root.estabelecimentos || []);
      this.$forceUpdate()
    },
    showErrorMsg(error, defaultMsg){
      let err = error.response && error.response.data ? error.response.data.error : defaultMsg;
      window.getApp.$emit("APP_ALERT", {
          color: "red",
          text: err,
      });
    },
    showSuccessMsg(msg){
      window.getApp.$emit("APP_ALERT", {
          color: "green",
          text: msg,
      });
    },
    open(estabelecimento){
      this.delivery = null;
      this.search = null;
      this.estabelecimento = estabelecimento;
      this.show = true;
      this.resetLimite();
      if(this.estabelecimentoSelecionado) this.search = this.estabelecimentoSelecionado.id
      // busca definida por código não passa pelo debounce
      this.searchAplicado = this.search || null;
      this.updateEstabelecimentos();
    },
    close(){
      this.show = false;
      this.estabelecimento = null;
    },
    async update (delivery) {
      try {
        const response = await this.$axios.put('/delivery', delivery);
        window.getApp.$emit('APP_UPDATE_DELIVERY', response.data);
      } catch (error) {
        window.getApp.$emit('APP_ALERT', { color: 'red', text: "Erro ao salvar os dados. Tente novamente!" });
      }
    },
    secToMin(minutes) {
      let hours = Math.floor(minutes / 60);
      let remainingMinutes = minutes % 60;
      let result = '';

      if (hours > 0) {
        result += hours > 1 ? `${hours} horas` : `${hours} hora`;
      }

      if (remainingMinutes > 0) {
        if(result.length > 0){
          result += ', ';
        }
        result += remainingMinutes > 1 ? `${remainingMinutes} minutos` : `${remainingMinutes} minuto`;
      }

      return result;
    },
  }
  }
</script>

<style lang="scss" scoped>
.content-text{
  white-space: normal !important;
  line-height: 1.3em;
}
</style>
